@if (owner) {
    <div class="specialist-container my-4 flex flex-col lg:flex-row">
        <div class="contact items-center justify-center flex">
            Kontaktujte <br class="hidden lg:flex" />
            specialistu
        </div>
        <div
            class="specialist-container-inner p-2 flex flex-auto flex-col justify-center gap-2 md:gap-0 md:flex-row md:items-center">
            <div class="flex items-center gap-2">
                <img [src]="owner.photo" class="w-12 h-12 user-select-none" />
                <span> {{ owner.titleBefore }} {{ owner.firstName }} {{ owner.lastName }} {{ owner.titleAfter }} </span>
            </div>
            @if (owner.phone) {
                <div class="flex w-48 items-center gap-2">
                    <mat-icon>local_phone</mat-icon>
                    <a href="tel:{{ owner.phone }}">{{ owner.phone }}</a>
                </div>
            }
            @if (owner.email) {
                <div class="flex items-center gap-2">
                    <mat-icon>local_post_office</mat-icon>
                    <a class="break-all" href="mailto:{{ owner.email }}">{{ owner.email }}</a>
                </div>
            }
        </div>
    </div>
}
